import { Tooltip } from "@/components/shared/tooltip";
import { QaScore } from "@/v2/entities/qa-score/QaScore.model";
import { QaScoreButton } from "./QaScoreButton";
import styles from "./QaScore.module.scss";

type QaScoreResultLabelProps = Pick<
  QaScore,
  "type" | "autoScore" | "adjustedScore"
>;

export function QaScoreResultLabel({
  type,
  autoScore,
  adjustedScore,
}: QaScoreResultLabelProps) {
  const isAdjusted = adjustedScore != null && adjustedScore !== autoScore;

  if (!isAdjusted) {
    return <div className={styles.Label}>Result</div>;
  }

  return (
    <Tooltip>
      <Tooltip.Trigger>
        <div className={styles.Label}>
          <div className={styles.Adjusted} />
          Result
        </div>
      </Tooltip.Trigger>

      <Tooltip.Content>
        <div className={styles.AdjustedTooltip}>
          <div className={styles.Label}>Adjusted result </div>
          <div className={styles.Content}>
            {type === "binary" ? (
              <>
                <QaScoreButton
                  variant={"binary"}
                  value={autoScore}
                  active
                  label={"Not achieved"}
                  hint={"AI scored"}
                />

                <QaScoreButton
                  variant={"binary"}
                  value={adjustedScore}
                  active
                  label={"Achieved"}
                  hint={"Adjusted score"}
                />
              </>
            ) : (
              <>
                <QaScoreButton
                  value={autoScore}
                  active
                  hint={"AI scored"}
                />

                <QaScoreButton
                  value={adjustedScore}
                  active
                  hint={"Adjusted score"}
                />
              </>
            )}
          </div>
        </div>
      </Tooltip.Content>
    </Tooltip>
  );
}
